import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Logo } from "../components/shared/brand";
import { SubmitButton } from "../components/shared/buttons/submit-button";
import Typography from "../components/shared/typography";
import { siteConfig } from "../siteConfig";

function DeepLinkPage() {
  const { "*": rest } = useParams();
  const location = useLocation();
  const [message, setMessage] = useState("Redirecting to the app...");

  useEffect(() => {
    const deepLinkPath = rest ?? "";
    const query = location.search ?? "";

    console.log("deepLinkPath", deepLinkPath);
    console.log("query", query);

    // Normalize and map the incoming path to the app's expected route format
    const normalizePath = (raw: string) => {
      const cleaned = decodeURIComponent(raw)
        .replace(/^\/?/, "") // drop leading slash
        .replace(/^dl\//i, ""); // defensively drop a leading dl/

      const [first, ...restSegs] = cleaned.split("/");
      const key = (first ?? "").toLowerCase();

      const mappedFirst =
        (
          {
            chat: "chat",
            contacts: "contacts",
            account: "account",
            alerts: "alerts",
            gallery: "gallery",
            invite: "invite",
            "access-request": "access-request",
            "grant-access": "grant-access",
            "reject-access": "reject-access",
            "medical-records": "medical-records",
            // common aliases
            medicalrecords: "medical-records",
          } as Record<string, string>
        )[key] || key;

      return [mappedFirst, ...restSegs].filter(Boolean).join("/");
    };

    const appRoute = normalizePath(deepLinkPath);
    const deepLinkUrl = `harper://${appRoute}${query}`;

    // Add Smart App Banner meta tag for iOS
    const meta = document.createElement("meta");
    meta.name = "apple-itunes-app";
    meta.content = `app-id=6742652864, app-argument=${deepLinkUrl}`;
    document.head.appendChild(meta);

    // Attempt to open the mobile app
    window.location.href = deepLinkUrl;

    // Change message after 3 seconds if app hasn't opened
    const messageTimer = setTimeout(() => {
      setMessage("It looks like you don't have the Harper app installed.");
    }, 3000);

    return () => {
      clearTimeout(messageTimer);

      document.head.removeChild(meta);
    };
  }, [rest, location.search]);

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const query = location.search ?? "";
  const normalizedPath = useMemo(() => {
    const raw = rest ?? "";
    const cleaned = decodeURIComponent(raw)
      .replace(/^\/?/, "")
      .replace(/^dl\//i, "");
    const [first, ...restSegs] = cleaned.split("/");
    const key = (first ?? "").toLowerCase();
    const map: Record<string, string> = {
      chat: "chat",
      contacts: "contacts",
      account: "account",
      alerts: "alerts",
      gallery: "gallery",
      invite: "invite",
      "access-request": "access-request",
      "grant-access": "grant-access",
      "reject-access": "reject-access",
      "medical-records": "medical-records",
      medicalrecords: "medical-records",
    };
    const mappedFirst = map[key] || key;
    return [mappedFirst, ...restSegs].filter(Boolean).join("/");
  }, [rest]);

  return (
    <div className="min-h-screen bg-cream flex items-start justify-center p-4 ">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="flex justify-center">
          <Logo size="lg" />
        </div>

        <div className="space-y-4">
          <Typography variant="h3" className="text-terracotta">
            Opening Harper on your phone
          </Typography>
          <Typography variant="body1" className="text-gray-600">
            {message}
          </Typography>
        </div>

        <div className="flex flex-col gap-6 justify-center items-center">
          <div className="flex flex-col gap-4">
            <a
              href={siteConfig.iosAppStoreUrl}
              style={{ display: "inline-block" }}
            >
              <img
                src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1751068800"
                alt="Download on the App Store"
                style={{
                  width: "246px",
                  verticalAlign: "middle",
                  objectFit: "contain",
                }}
              />
            </a>
            <a
              href={siteConfig.androidPlayStoreUrl}
              style={{ display: "inline-block" }}
            >
              <img
                src="/images/google-play-badge.png"
                alt="Get it on Google Play"
                style={{
                  width: "246px",
                  verticalAlign: "middle",
                  objectFit: "contain",
                }}
              />
            </a>
          </div>
          <div>
            <a
              href={`${origin}/${normalizedPath}${query}`}
              className="w-full"
              style={{
                width: "246px",
                height: "82px",
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            >
              <SubmitButton
                color="terracotta"
                className="w-full sm:w-auto"
                size="lg"
              >
                Continue in browser
              </SubmitButton>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeepLinkPage;
